import React from 'react';
import { SkeletonCard, Skeleton } from '@repo/ui';

export const LoadingState: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Page Header Skeleton */}
      <div className="flex items-center justify-between mb-2">
        <div>
          <Skeleton variant="text" width="120px" height="2.25rem" className="mb-2" />
          <Skeleton variant="text" width="450px" height="1rem" />
        </div>
      </div>

      <div className="space-y-8">
        {/* Organization Card Skeleton */}
        <div className="bg-white dark:bg-xtnd-dark-700 rounded-xl p-6 border border-xtnd-dark-100 dark:border-xtnd-dark-600">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Skeleton variant="circular" width={56} height={56} />
              <div>
                <Skeleton variant="text" width="100px" className="mb-2" />
                <Skeleton variant="text" width="200px" height="1.25rem" className="mb-2" />
                <Skeleton variant="text" width="150px" />
              </div>
            </div>
            <Skeleton variant="rectangular" width="100px" height="40px" />
          </div>
        </div>

        {/* Integration Cards Skeleton */}
        <div>
          <div className="flex items-center space-x-3 mb-6">
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="text" width="200px" height="1.5rem" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </div>
        </div>
      </div>
    </div>
  );
};

